import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import loadingReducer from './slices/loading.slice';
import recaptchaReducer from './slices/recaptcha.slice';
import checkoutReducer from './slices/checkout.slice';
import timerReducer from './slices/pix-timer.slice';
import eventReducer from './slices/event.slice';
import clientDataReducer from './slices/client-data.slice';
import { expireCheckoutItems24h } from './persistence';

const checkoutPersistConfig = {
  key: 'checkout',
  storage,
  transforms: [expireCheckoutItems24h],
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['timer', 'event', 'clientData'],
};

const rootReducer = combineReducers({
  loading: loadingReducer,
  recaptcha: recaptchaReducer,
  timer: timerReducer,
  checkout: persistReducer(checkoutPersistConfig, checkoutReducer),
  event: eventReducer,
  clientData: clientDataReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
